import "./HowItWorks.module.css";
import Header from "@/reusable_sections/Header";
import Authority from "./sections/Authority";
import PatronageConditions from "./sections/PatronageConditions";
import WhatHseReimburses from "./sections/WhatHseReimburses";
import DocumentsYouWillNeed from "./sections/DocumentsYouWillNeed";
import Footer from "@/reusable_sections/Footer";
export default function HowItWorksPage() {
  return <div>
      <Header />
      <Authority />
      <PatronageConditions />
      <WhatHseReimburses />
      <DocumentsYouWillNeed />
      <Footer />
    </div>;
}